import useAuth from '../../hooks/useAuth';
import { useEffect } from 'react';
import { ICartItem } from 'components/Checkout/requests/CartSummaryRequest';
import useCartSummary from '../../hooks/useCartSummary';

const handleCartUpdated = (e) => {
    const details = e.detail;

    if (!window.klaviyo || !details) {
        return;
    }

    if (details.action === 'add-to-cart') {
        const cartItems: ICartItem[] = details.cartItems ?? [];
        const cartValue = cartItems.reduce((sum, item) => sum + item.row_total, 0);

        window.klaviyo.track('Added To Cart', {
            $value: cartValue + details.price,
            AddedItemProductName: details.name,
            AddedItemProductID: details.productId,
            AddedItemSku: details.sku,
            AddedItemPrice: details.price,
            AddedItemQuantity: details.qty,
            Items: cartItems.map((item) => ({
                ProductID: item.id,
                Title: item.name,
                Quantity: item.qty,
                Price: item.price,
                Url: item.url,
                Image: item.image,
                Brand: item.brand,
            })),
        });
    }
};

const handleCheckoutStep = (e) => {
    const details = e.detail;

    if (!window.klaviyo || !details) {
        return;
    }

    const klaviyo = window.klaviyo;

    if (details.action === 'add-contact-info') {
        klaviyo.isIdentified().then((identified) => {
            if (!identified && details.email) {
                klaviyo.identify({
                    $email: details.email,
                    $first_name: details.customer.firstname ?? '',
                    $last_name: details.customer.lastname ?? '',
                });
            }
        });
    }
};

export default function Events() {
    const { customer } = useAuth();
    const { cartItems } = useCartSummary();

    useEffect(() => {
        if (!window.klaviyo) {
            return;
        }

        const klaviyo = window.klaviyo;

        klaviyo.isIdentified().then((identified) => {
            if (customer && customer.email && !identified) {
                klaviyo.identify({
                    $email: customer.email,
                    $first_name: customer.firstName,
                    $last_name: customer.lastName,
                });
            }
        });
    }, [customer]);

    useEffect(() => {
        window.addEventListener('cartUpdated', handleCartUpdated);
        window.addEventListener('checkout-step-proceed', handleCheckoutStep);
    }, []);

    useEffect(() => {
        const klaviyo = window.klaviyo;

        if (klaviyo && cartItems.length > 0 && window.location.pathname === '/fast/checkout/') {
            const cartValue = cartItems.reduce((sum, item) => sum + item.row_total, 0);

            klaviyo.track('Started Checkout', {
                $value: cartValue,
                Items: cartItems.map((item) => ({
                    ProductID: item.id,
                    ProductName: item.name,
                    Quantity: item.qty,
                    Price: item.price,
                    ProductImage: item.image,
                })),
            });
        }
    }, [cartItems]);

    return null;
}
